/* Alova PDP - FAQ accordion + Tabs interactions */
(function () {
  function initAccordion(scope) {
    var headers = scope.querySelectorAll('.alova-pdp-faq__header');
    headers.forEach(function (header) {
      if (header.dataset.bound === '1') return;
      header.dataset.bound = '1';
      header.addEventListener('click', function () {
        var item = header.closest('.alova-pdp-faq__item');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        // Close all in this faq group
        var faqRoot = item.closest('.alova-pdp-faq');
        if (faqRoot) {
          faqRoot.querySelectorAll('.alova-pdp-faq__item').forEach(function (it) {
            it.classList.remove('is-open');
          });
        }
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initTabs(scope) {
    var tabContainers = scope.querySelectorAll('.alova-pdp-tabs');
    tabContainers.forEach(function (container) {
      if (container.dataset.bound === '1') return;
      container.dataset.bound = '1';
      var btns = container.querySelectorAll('.alova-pdp-tabs__btn');
      var panels = container.querySelectorAll('.alova-pdp-tabs__panel');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-tab');
          btns.forEach(function (b) { b.classList.remove('alova-pdp-tabs__btn--active'); });
          panels.forEach(function (p) { p.classList.remove('alova-pdp-tabs__panel--active'); });
          btn.classList.add('alova-pdp-tabs__btn--active');
          var panel = container.querySelector('[data-panel="' + target + '"]');
          if (panel) panel.classList.add('alova-pdp-tabs__panel--active');
        });
      });
    });
  }

  function initAll() {
    initAccordion(document);
    initTabs(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
